
import Component from "vue-class-component";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";

import {
    AddPilotagePracticeRequest,
    factory, PracticesClient,
    PilotagePracticeActions,
} from "@/api-client";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import PilotagePracticeUpsertForm from "@/features/documents/practices/components/PilotagePracticeUpsertForm.vue";
import {PracticeAddBase} from "@/features/documents/practices/views/PracticeAddBase";

interface Props {
    seafarerId: string;
    actions: PilotagePracticeActions;
}

@Component({
    components: {
        FormLayout,
        PilotagePracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<AddPilotagePractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        Promise.all([
            new PracticesClient().availablePilotageActions()
        ]).then(values => {
            props.actions = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class AddPilotagePractice extends PracticeAddBase<AddPilotagePracticeRequest> implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: PilotagePracticeActions;

    model: AddPilotagePracticeRequest = factory.create(AddPilotagePracticeRequest);

    async submitPractice(model: AddPilotagePracticeRequest, saveAndAddNew?: boolean) {
        if (saveAndAddNew) {
            // For save and add new, just save without navigation
            return await new PracticesClient()
                .add(model, this.seafarerId)
                .then(() => {
                    // Don't navigate, just return to allow form reset
                    return Promise.resolve();
                });
        } else {
            // Normal save with navigation
            return await this.submit(model);
        }
    }

    getDefaultReturnRouteName(): string {
        return "pilotage-practice-details";
    }
}
